import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import './SizeListCheckbox.css'; // Add CSS for better visibility
import { setSizeSelectedList } from '../../../API/Reducer/fabricReducer';

const SizeListCheckbox = () => {
    const dispatch=useDispatch(); 
    const { sizeSelectedList } = useSelector((state) => state.fabric);
 
    const handleCheckboxChange = (id) => {          
        const updatedItems = sizeSelectedList.map((item) =>
            item.id === id ? { ...item, 
                is_check: item?.is_check===false?true:true } : item
        );
        dispatch(setSizeSelectedList(updatedItems));
     };
    return (
        <Container fluid style={{ fontSize: '16px' }}>
            <Row
                className="gy-3 scrollable-row"
                style={{
                    maxHeight: '300px', // Set maximum height
                    overflowY: 'auto', // Enable vertical scrolling
                    padding: '10px', // Compact padding
                }}
            >
                {sizeSelectedList?.map((element) => (
                    <Col key={element?.id} xs={3} className="d-flex align-items-center">
                        <div className="form-check custom-checkbox">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={`flexCheck${element?.id}`}
                                checked={element?.is_check}
                                onChange={(e) => {                              
                                handleCheckboxChange(element?.id)}}
                            />
                            <label
                                className="form-check-label ms-2"
                                htmlFor={`flexCheck${element?.id}`}
                            >
                                {element?.sizename}
                            </label>
                        </div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default SizeListCheckbox;
